// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".password-protect[data-v-bab5115e]{width:calc(100% - 18px);margin-left:18px}\n", ""]);
// Exports
module.exports = exports;
